import React from 'react'
import {
  CMSPath,
  days,
  months,
  errorMsg
} from '../../../config/constant'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import './weather-icons-wind.css';
import './weather-icons.css';
import { checkStatus } from '../../shared/facebookOauth';
import { fbCheckStatus } from '../../shared/facebookOauthMobile';
import { twitterOauth, twitterPost } from '../../shared/twitterOauth';
import fbLogImg from '../../../images/fb_icon.png';
import {
  fetchFaceBasedJson,
  logoutFb,
  setFacebookPopup,
  popupOpenClose,
  setRegPage
} from '../../../action/action'
import Popup from '../../../UI/popup/popup'
import axios from 'axios'

const getCurrentWeather = (props) => {
  let curWeather = null, todaysWeather;
  let serverDate = new Date(props.serverDate.date);
  let fromDate, toDate;
  props.weatherInfo.map((iterator) => {
    if (iterator.city.isDefault) {
      curWeather = iterator;
    }
    return 0;
  })
  //console.log("curWeather", curWeather);
  if (curWeather) {
    curWeather.forecast.map((iterator) => {
      fromDate = new Date(iterator.fromDate);
      toDate = new Date(iterator.toDate);
      if (fromDate <= serverDate && serverDate <= toDate) {
        todaysWeather = iterator;
      }
    })
  }
  //console.log("todaysWeather", todaysWeather);
  return todaysWeather
}

class userInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temp: 20,
      weather: {},
      currentWeather: {},
      profileImage: null
    }
  }

  static getDerivedStateFromProps(props) {
    let currentWeather;
    currentWeather = getCurrentWeather(props);
    return {
      currentWeather
    }
  }

  //Increase temprature function
  tempIncrease = async () => {
    if (this.props.guestInRoom) {
      let temp = this.state.temp + 1;
      this.setState({ temp: temp });
    }
    else {
      this.props.popupOpenClose(true, errorMsg);
    }
    //twitterPost("we are in user info now and tweeting from there");
    //this.fbLogout(); 
  }
  //decrease temprature function
  tempDecrease = async () => {
    if (this.props.guestInRoom) {
      let temp = this.state.temp - 1;
      this.setState({ temp: temp });
    } else {
      this.props.popupOpenClose(true, errorMsg);
    }
    //this.props.setFacebookPopup(true);
  }

  fetchFBName = (faceUserProfile, guestInstaProfile, guestTwitterProfile, cmsGuestData) => {
    let guestName = "";
    let fbData = localStorage.getItem("FB_user_info");
    fbData = JSON.parse(fbData);
    guestName = guestTwitterProfile && guestTwitterProfile.name ?
      guestTwitterProfile.name :
      guestInstaProfile && guestInstaProfile.data.full_name ?
        guestInstaProfile.data.full_name :
        fbData && fbData.first_name ? fbData.first_name : cmsGuestData ?
          cmsGuestData : null
    //console.log("guestName", guestName);
    return guestName
  }

  getGreeting = (hours) => {
    if (Object.keys(this.props.stringConst).length > 0) {
      return hours >= 5 && hours < 12 ?
        this.props.stringConst.allGreeting[0] :
        hours >= 12 && hours < 17 ?
          this.props.stringConst.allGreeting[1] :
          hours >= 17 || hours < 5 ?
            this.props.stringConst.allGreeting[2] : null
    }
    //return "Click here to login to your room"
  }

  //method to format the Date as needed
  getDate = (date) => {
    let serverDate = this.props.serverDate.date;
    let month, currentdate;
    if (serverDate) {
      month = serverDate.slice(5, 7);
      month = parseInt(month);
      currentdate = serverDate.slice(8, 10)
    }
    return serverDate ?
      `${this.props.serverDate.currentDay} 
    ${currentdate} ${months[month - 1]}` :
      `${days[date.getDay()]}
    ${date.getDate()}
     ${months[date.getMonth()]}`
  }
  //method to format the time as needed
  getTime = (date) => {
    try {
      let min = this.props.serverTime.minutes ?
        this.props.serverTime.minutes :
        date.getMinutes()
      if (min < 10) { min = `0${min}` }
      return this.props.serverTime.minutes ?
        `${this.props.serverTime.hours}:${min}` :
        `${date.getHours()}:${min}`
    } catch (e) {
      console.log("error in get Time method", e);
    }
  }

  facebookProfileData = () => {
    let fbCheck = localStorage.getItem("FB_user_info");
    let guestInstaProfile = localStorage.getItem("guestInstaProfile");
    if (fbCheck && fbCheck !== "null") {
      fbCheck = JSON.parse(fbCheck);
    } else {
      fbCheck = ""
    }
    if (fbCheck && fbCheck.name) {
      console.log("we have facebook data");
    } else if (guestInstaProfile !== null && guestInstaProfile !== "") {
      console.log("we have Instagram data");
    } else {
      //this.props.setFacebookPopup(true);
    }
    //this.props.setFacebookPopup(true);
    this.props.setRegPage(true);
  }

  greetings = (hours, faceUserProfile, guestInstaProfile, guestTwitterProfile, cmsGuestName) => {
    let guestName = this.fetchFBName(faceUserProfile, guestInstaProfile, guestTwitterProfile, cmsGuestName);
    let room = localStorage.getItem("room");
    let greet = this.getGreeting(hours);
    let greetingLine1 = this.props.profile.greetingsLine1 ?
      typeof this.props.profile.greetingsLine1 === 'string' ||
        this.props.profile.greetingsLine1 instanceof String ?
        this.props.profile.greetingsLine1.trim() :
        null : null
    let greetingLine2 = this.props.profile.greetingsLine2 ?
      typeof this.props.profile.greetingsLine2 === 'string' ||
        this.props.profile.greetingsLine2 instanceof String ?
        this.props.profile.greetingsLine2.trim() : null :
      null;
    let greetingLine3 = this.props.profile.greetingsLine3 ?
      typeof this.props.profile.greetingsLine3 === 'string' ||
        this.props.profile.greetingsLine3 instanceof String ?
        this.props.profile.greetingsLine3.trim() :
        null : null

    if (greetingLine1 || greetingLine2 || greetingLine3) {
      if (room && room !== "null") {
        if (greetingLine2 && greetingLine2.indexOf("#GUEST_NAME#") !== -1) {
          if (guestName) {
            return greetingLine2.replace("#GUEST_NAME#", guestName);
          } else {
            return greet
          }
        } else if (greetingLine3 && greetingLine3.indexOf("#GUEST_NAME#") !== -1) {
          if (guestName) {
            return greetingLine3.replace("#GUEST_NAME#", guestName);
          } else {
            return greet
          }
        } else if (greetingLine2.indexOf("#ROOM#")) {
          return greetingLine2.replace("#ROOM#", guestName);
        } else if (greetingLine3.indexOf("#ROOM#")) {
          return greetingLine3.replace("#ROOM#", guestName);
        } else {
          return greetingLine3
        }
      } else {
        return greetingLine1
      }
    } else {
      return "Click here to login to your room";//"" ? greet : "Good Morning";
    }
  }

  fetchUserProfile = (faceUserProfile, guestInstaProfile, guestTwitterProfile) => {
    let CMSProfileImage = this.props.profile.profileImageUrl ?
      `${CMSPath}${this.props.profile.profileImageUrl}` : fbLogImg
    faceUserProfile = faceUserProfile && faceUserProfile !== "null" ?
      this.props.facebookProfile && this.props.facebookProfile !== "null" ?
        this.props.facebookProfile : null
      : null
    guestInstaProfile = guestInstaProfile && guestInstaProfile.data ?
      guestInstaProfile.data.profile_picture : null;
    //userNames = guestInstaProfile.data.full_name
    guestTwitterProfile = guestTwitterProfile ?
      guestTwitterProfile.profile_image_url_https : null
    // userProfile = profile ? profile : userProfile;
    return guestTwitterProfile ? guestTwitterProfile :
      guestInstaProfile ? guestInstaProfile :
        faceUserProfile ? faceUserProfile :
          CMSProfileImage
  }

  getWeatherIcon = () => {
    let fcode = String.fromCharCode(parseInt(this.state.currentWeather.fontCode, 16))
    //console.log("fontcode", this.state.currentWeather.fontCode);
    return fcode
  }

  render() {
    let profilestyle = {
      "min-width": "fit-content !important",
      "color": "red"
    }
    //console.log("serverDate",this.props.serverDate);
    let faceUserProfile = localStorage.getItem("user_profile");
    let guestInstaProfile = localStorage.getItem("guestInstaProfile");
    let guestTwitterProfile = localStorage.getItem("TwitterUserData");
    guestInstaProfile = guestInstaProfile ?
      JSON.parse(guestInstaProfile) : null;
    guestTwitterProfile = guestTwitterProfile ?
      JSON.parse(guestTwitterProfile) : null;
    let userProfile;
    let profile, userNames;
    userProfile = this.fetchUserProfile(
      faceUserProfile,
      guestInstaProfile,
      guestTwitterProfile);
    let date = new Date();
    let greetingLine = ""
    greetingLine = this.greetings(date.getHours(), faceUserProfile, guestInstaProfile, guestTwitterProfile, this.props.guestName);
    //console.log("this.props.guestName", this.props.guestName)
    //console.log(this.props.menuColor.assetBackgroundColor);
    //let greetingLine2 = this.getGreetingLine2(date.getHours())
    return (
      <div id="usrInfo" className="widget col col-2 h-auto m-r25">
        {/*User profile div*/}
        <div id="usrProfile" className="widget-contents subwidget">
          <div className="widget-body">
            <div className="align-center columns" onClick={this.facebookProfileData} >
              {/*
            below is onClick from above div it is for facebook and other login button popup 
            onClick={this.facebookProfileData} 
            */
              }
              <div className="col col-2" style={{ minWidth: 'fit-content' }}>
                {userProfile ?
                  <img
                    // style={{ width: '106px', height: '106px' }}
                    className="prfile-circle"
                    src={userProfile}
                    alt="" /> : null
                }
              </div>
              <div className="col col-2" style={{ minWidth: 'fit-content' }}>
                <div className="greet">
                  {greetingLine}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*time date and temprature control div*/}
        <div id="usrCtrl" className="widget-contents subwidget">
          <div className="widget-body">
            <div className="columns">
              <div id="dateTime" className="col">
                <div id="timeWidget">
                  <div
                    id="currentDate"
                    className="date center">
                    {this.getDate(date)}
                  </div>
                  <div
                    id="currentTime"
                    className="time center">
                    {this.getTime(date)}
                  </div>
                </div>
                <div id="weatherWidget" style={{ position: "relative" }}>
                  <p className="weather center">
                    {this.state.currentWeather ? this.state.currentWeather.symbolName : "sunny"}
                    {this.state.currentWeather ?
                      <i style={{ /*marginLeft: "5px",*/ color: "inherit" }}
                        className="wi">
                        {this.getWeatherIcon()}
                      </i> :
                      <i className="fa fa-sun-o"></i>
                    }
                  </p>
                </div>
              </div>
              <div id="roomTemp" className="col col-2" style={{ display: "none" }}>
                <p className="center my-label">
                  {this.props.stringConst.RoomTemp}
                </p>
                <p id="currentTemp" className="temp center">
                  {this.state.temp}
                  <span className="sup">o</span>
                </p>
                <p id="labelTemp" className="center my-label">
                  {this.props.stringConst.tempCont}
                </p>
                <div className="controls center">
                  <span>
                    <button
                      className="temp-ctl-bt my-label"
                      onClick={this.tempIncrease}>
                      <i className="fa fa-plus"></i>
                    </button>
                  </span>
                  <span>
                    <button
                      className="temp-ctl-bt my-label minus"
                      onClick={this.tempDecrease}>
                      <i className="fa fa-minus"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

//export default home;
const mapStateToProps = state => {
  return {
    //user profile data
    profile: state.store.home.currentDuration.brandingInfo.app ?
      state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
    //guest name
    guestName: state.store.home.guestDetails ?
      state.store.home.guestDetails.guestName : null,
    //Get server time
    serverTime: state.store.home.serverTimeDate.time ?
      state.store.home.serverTimeDate.time : {},
    //get server date
    serverDate: state.store.home.serverTimeDate,
    //weasther data
    weatherInfo: state.store.home.weatherInfo.data ?
      state.store.home.weatherInfo.data.payload.weather : [],
    //
    stringConst: state.store.home.stringConst,
    fbStatus: state.store.fbStatus,
    facebookProfile: state.store.facebookProfile,
    guestInRoom: state.store.guestInRoom,
    menuColor: state.store.home.MenuColor
  }
}

userInfo.propTypes = {
  profile: propTypes.object,
  serverTime: propTypes.object,
  serverDate: propTypes.string,
  weatherInfo: propTypes.arrayOf(propTypes.object),
  guestName: propTypes.string,
  stringConst: propTypes.object,
  fbStatus: propTypes.string,
  facebookProfile: propTypes.string
}

export default connect(
  mapStateToProps, {
  fetchFaceBasedJson,
  logoutFb,
  setFacebookPopup,
  popupOpenClose,
  setRegPage
}
)(userInfo);